<template>
  <div class="active-dark bg_color--10">
    <!-- Start Header Area -->
    <Header>
      <img slot="logo" :src="logo" />
    </Header>
    <!-- End Header Area -->

    <!-- Start Slider Area  -->
    <div class="rn-slider-area">
      <div
        class="justify-center slide slide-style-2 fullscreen d-flex align-center bg_image bg_image--35"
        data-black-overlay="6"
      >
        <Banner>
          <h1 slot="heading-title" class="heading-title theme-gradient">
            R.A.D Software Development Services
          </h1>
          <p slot="description" class="description">
            Empowering businesses with cutting-edge web and mobile solutions, 
            comprehensive marketing strategies, and expert server management services.
          </p>
          <router-link
            slot="button"
            class="btn-default btn-border btn-opacity"
            to="/contact"
            >Get Started</router-link
          >
        </Banner>
      </div>
    </div>
    <!-- End Slider Area  -->

    <!-- Start Portfolio Area  -->
    <div class="rn-portfolio-area bg_color--10 ptb--120">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="text-center section-title mb--30">
              <span class="subtitle">Our Expertise</span>
              <h2 class="heading-title">Our Services</h2>
              <p class="description">
                We deliver comprehensive software solutions tailored to your business needs,
                <br />
                ensuring optimal performance and growth.
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <div class="wrapper plr--30">
        <PortfolioSix />
        <v-row>
          <v-col lg="12">
            <div class="text-center view-more-btn mt--60">
              <a class="btn-default" href="portfolio"
                ><span>View More Project</span></a
              >
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- End Portfolio Area  -->

    <!-- Start Service Area  -->
    <div class="service-area pb--120 bg_color--10" id="service">
      <div class="container">
        <v-row>
          <v-col lg="12">
            <div class="text-center section-title">
              <span class="subtitle">What we offer</span>
              <h2 class="heading-title">Our Services</h2>
              <p class="description">
                Comprehensive software development and IT solutions to help your business thrive
                <br />
                in the digital landscape.
              </p>
            </div>
          </v-col>
        </v-row>
        <ServiceThree />
      </div>
    </div>
    <!-- Start Service Area  -->

    <!-- Start Progress Area  -->
    <div class="rn-progress-area pb--120 bg_color--10">
      <v-container class="container">
        <v-row class="row--35 align-items-center">
          <v-col lg="6" md="6" cols="12">
            <div class="">
              <img
                class="w-100"
                src="../../assets/images/about/about-14.png"
                alt="About Images"
              />
            </div>
          </v-col>
          <v-col lg="6" md="6" cols="12" class="mt_md--30 mt_sm--30">
            <div class="progress-content-here">
              <div class="section-title text-left">
                <span class="subtitle">Our Expertise</span>
                <h2 class="heading-title">Technical Excellence</h2>
                <p class="description">
                  With years of experience in software development and IT services,
                  we deliver solutions that drive business success.
                </p>
              </div>
              <div class="progress-wrapper">
                <div class="rn-progress-charts progress-bar--3">
                  <h6 class="heading heading-h6">Backend Development (Laravel/PHP, Node.js, Python)</h6>
                  <div class="progress fadeInLeft">
                    <div class="progress-bar" style="width: 95%;">
                      <span class="percent-label">95%</span>
                    </div>
                  </div>
                </div>
                <div class="rn-progress-charts progress-bar--3">
                  <h6 class="heading heading-h6">Frontend Development (Vue.js, React.js, Quasar)</h6>
                  <div class="progress">
                    <div class="progress-bar" style="width: 95%;">
                      <span class="percent-label">95%</span>
                    </div>
                  </div>
                </div>
                <div class="rn-progress-charts progress-bar--3">
                  <h6 class="heading heading-h6">Database Management (MySQL, PostgreSQL, MongoDB)</h6>
                  <div class="progress">
                    <div class="progress-bar" style="width: 92%;">
                      <span class="percent-label">92%</span>
                    </div>
                  </div>
                </div>
                <div class="rn-progress-charts progress-bar--3">
                  <h6 class="heading heading-h6">Mobile Development (Flutter, Ionic, Framework7)</h6>
                  <div class="progress">
                    <div class="progress-bar" style="width: 90%;">
                      <span class="percent-label">90%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Progress Area  -->

    <!-- Start Brand Area  -->
    <!-- <div class="rn-brand-area pb--120 bg_color--10">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="section-title text-center mb--30">
              <span class="subtitle">Client Success</span>
              <h2 class="heading-title">What Our Clients Say</h2>
            </div>
          </v-col>
        </v-row>
        <div class="video-image-wrapper mt--30">
          <v-container>
            <v-row>
              <v-col lg="10" offset-lg="1">
                <div class="thumb position-relative">
                  <CoolLightBox
                    :items="items"
                    :index="index"
                    @close="index = null"
                  >
                  </CoolLightBox>

                  <div class="thumbnail position-relative">
                    <div v-for="(image, imageIndex) in items" :key="imageIndex">
                      <img
                        class="w-100"
                        :src="image.thumb"
                        alt="About Images"
                      />
                      <a
                        @click="index = imageIndex"
                        class="video-popup position-top-center theme-color"
                        ><span class="play-icon"></span
                      ></a>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-container>
    </div> -->
    <!-- End Brand Area  -->

    <!-- Start Footer Area  -->
    <Footer />
    <!-- End Footer Area  -->
  </div>
</template>

<script>
  import Header from "../../components/header/Header";
  import Banner from "../../components/slider/Banner";
  import PortfolioSix from "../../components/portfolio/PortfolioSix";
  import ServiceThree from "../../components/service/ServiceThree";
  import Footer from "../../components/footer/FooterTwo";

  export default {
    components: {
      Header,
      Banner,
      PortfolioSix,
      ServiceThree,
      Footer,
    },
    data() {
      return {
        items: [
          {
            thumb: require("../../assets/images/blog/bl-big-02.jpg"),
            src: "https://www.youtube.com/watch?v=ZOoVOfieAF8",
          },
        ],
        index: null,
        logo: require("../../assets/images/logo/logo-ko.png"),
      };
    },
  };
</script>
